import React, { useEffect, useRef } from 'react';
import AreaTitle from '../../components/areaTitle/AreaTitle';
import { LogoutAPI } from '../../api/API';
import { clearAccessToken } from '../../api/authTokens';
import styles from './Logout.module.css';

// Tempo máximo esperando o servidor revogar a sessão antes de sair mesmo assim
const LOGOUT_TIMEOUT_MS = 3000;

/**
 * Rota /logout: "Sair" no menu já é a confirmação, então a sessão é encerrada
 * ao abrir a rota e a pessoa vai direto para o login (sem um segundo botão).
 */
function Logout() {
  // Uma vez só, mesmo com o efeito rodando duas vezes no StrictMode
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const doLogout = async () => {
      // Revoga a sessão no servidor e apaga o cookie de renovação. Se o servidor
      // demorar, sai assim mesmo: a limpeza local abaixo acontece de qualquer jeito.
      await Promise.race([
        LogoutAPI(),
        new Promise((resolve) => setTimeout(resolve, LOGOUT_TIMEOUT_MS))
      ]);

      // Descarta o token em memória e o estado salvo da sessão
      // (sessionData removido também encerra a sessão nas outras abas)
      clearAccessToken();
      localStorage.removeItem('userData');
      localStorage.removeItem('sessionData');
      localStorage.setItem('isAuthenticated', 'false');
      window.location.href = '/';
    };

    doLogout();
  }, []);

  return (
    <div className='page-content'>
      <div className={styles.container}>
        <AreaTitle Title='Saindo...' Description='Encerrando a sua sessão.' />
      </div>
    </div>
  );
}

export default Logout;
